var questionGrader = Object.freeze({
   FATHOM: 'FATHOM',
   XMP: 'XMP'
});

export default questionGrader;
